import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerCmModalComponent} from './worker-cm-modal';

export const WorkerCmModalModule: string = ng
    .module('worker-cm-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerCmModalComponent', WorkerCmModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-cm-modal/worker-cm-modal.module.ts